module.exports = __webpack_public_path__ + "static/media/check-list.12a8f7a7.png";